export const manifest = {
  screens: {
    scr_ms7fzn: { name: "1 · Title", route: "/", state: {"slide":0}, position: {"x":160,"y":220} },
    scr_2r8l11: { name: "2 · Why Snaks & Scope", route: "/", state: {"slide":1}, position: {"x":9960,"y":220} },
    scr_ggupy7: { name: "3 · Evergreen Webinar Snak", route: "/", state: {"slide":2}, position: {"x":160,"y":2200} },
    scr_d6yqei: { name: "4 · Teaser-to-Insight Flow", route: "/", state: {"slide":3}, position: {"x":1560,"y":2200} },
    scr_urpvjw: { name: "5 · 3-Month Performance Readout", route: "/", state: {"slide":4}, position: {"x":160,"y":4180} },
    scr_liz6eg: { name: "6 · Cost Estimate", route: "/", state: {"slide":5}, position: {"x":18360,"y":220} },
  },
  sections: {
    sec_k9nyik: { name: "Webinar to Series Strategy", x: 0, y: 0, width: 21120, height: 1180 },
    sec_vistwo: { name: "Campaign Execution", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_cieylm: { name: "Operations & Commercial", x: 0, y: 3960, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_k9nyik", children: [
      { kind: "screen", id: "scr_ms7fzn" },
      { kind: "screen", id: "scr_2r8l11" },
      { kind: "screen", id: "scr_liz6eg" },
    ] },
    { kind: "section", id: "sec_vistwo", children: [
      { kind: "screen", id: "scr_ggupy7" },
      { kind: "screen", id: "scr_d6yqei" },
    ] },
    { kind: "section", id: "sec_cieylm", children: [
      { kind: "screen", id: "scr_urpvjw" },
    ] },
  ],
}
